import React from 'react'
import { Controller } from 'react-hook-form'
import PropTypes from 'prop-types'
import PassInputView from './view'

const PassInput = ({ control, rules, name, label, ...props }) => (
  <Controller
    render={({ value, onChange, field }) => (
      <PassInputView label={label} onChange={onChange} value={value} variant='outlined' fullWidth {...props} {...field} />
    )}
    name={name}
    control={control}
    rules={rules}
  />
)

PassInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  label: PropTypes.string,
  control: PropTypes.object.isRequired,
  rules: PropTypes.object,
  name: PropTypes.string.isRequired,
}

PassInput.defaultProps = {
  label: '',
  value: '',
  onChange: () => null,
  rules: {},
}

export default PassInput
